<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div>
          <div class="headline">Unit Of Measure Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.uom }}</td>
          <td class="text-xs-left">{{ props.item.uomShortDesc }}</td>
          <td class="text-xs-left">{{ props.item.uomLongDesc }}</td>
          <td class="text-xs-left">{{ formatBoolean(props.item.isExcess) }}</td>
          <td class="text-xs-left">{{ formatBoolean(props.item.isSumInsured) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNew">New Uom<v-icon>mdi-plus</v-icon></v-btn>
    </v-card>
    <v-dialog v-model="uomDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ labels.valueFormTitle }}</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 v-if="newUom">
                  <v-text-field v-model="uomForm.uom" :label="labels.uom" :error-messages="errors.collect('uom')" data-vv-name="uom" :data-vv-as="labels.uom" v-validate="'required|param|max:4'"></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{labels.uom}}</v-subheader>
                  <div class="subheading">{{uomForm.uom}}</div>
                </v-flex>
                <v-flex xs-6></v-flex>
                <v-flex xs6>
                  <v-text-field v-model="uomForm.uomShortDesc" :label="labels.uomShortDesc" :error-messages="errors.collect('uomShortDesc')" v-validate="'required|entry|max:40'" data-vv-name="uomShortDesc" :data-vv-as="labels.uomShortDesc"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="uomForm.uomLongDesc" :label="labels.uomLongDesc" :error-messages="errors.collect('uomLongDesc')" v-validate="'required|entry|max:100'" data-vv-name="uomLongDesc" :data-vv-as="labels.uomLongDesc"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :label="labels.isExcess" v-model="uomForm.isExcess"></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :label="labels.isSumInsured" v-model="uomForm.isSumInsured"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected item?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import FieldMixin from '@/mixins/field'
export default {
  data() {
    return {
      headers: [
        { text: 'Uom Code', value: 'uom' },
        { text: 'Uom Short Description', value: 'uomShortDesc' },
        { text: 'Uom Long Description', value: 'uomLongDesc' },
        { text: 'Is Excess', value: 'isExcess' },
        { text: 'Is Sum Insured', value: 'isSumInsured' },
        TableConst.tableActionHeader
      ],
      labels: {
        valueFormTitle: 'Unit Of Measure Details',
        uom: 'Uom Code',
        uomShortDesc: 'Uom Short Description',
        uomLongDesc: 'Uom Long Description',
        isExcess: 'Is Excess?',
        isSumInsured: 'Is Sum Insured?'
      },
      uomForm: {
        uom: null,
        uomShortDesc: null,
        uomLongDesc: null,
        isExcess: null,
        isSumInsured: null
      },
      uomDialog: null,
      newUom: null,
      selectedId: {
        id: null,
        text: null
      },
      promptRemove: false
    }
  },
  computed: {
    uom() {
      return this.$store.state.parameters.uom
    }
  },
  methods: {
    async init() {
      this.loading = true
      this.selectedId.id = null
      this.selectedId.text = null
      const apiURI = this.uom.menu.getUoms
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((uom) => {
              const convertUom = {
                uom: uom.uom,
                uomShortDesc: uom.uomShortDesc,
                uomLongDesc: uom.uomLongDesc,
                isExcess: uom.isExcess,
                isSumInsured: uom.isSumInsured
              }
              this.items.push(convertUom)
            })
            this.loading = false
          }
        } catch (error) {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    },
    async doInit() {
      await this.$store.dispatch('uomInit')
      this.init()
    },
    async doReview(data) {
      this.uomDialog = true
      this.newUom = false
      const apiURI = this.uom.menu.getUom
      const expand = {
        uom: data.item.uom
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.uomForm.uom = data.uom.uom
          this.uomForm.uomShortDesc = data.uom.uomShortDesc
          this.uomForm.uomLongDesc = data.uom.uomLongDesc
          this.uomForm.isExcess = data.uom.isExcess
          this.uomForm.isSumInsured = data.uom.isSumInsured
        }
        this.uomDialog = true
      }
    },
    doNew() {
      this.resetValidator()
      this.resetMessages()
      this.newUom = true
      this.uomDialog = true
      this.uomForm.isExcess = false
      this.uomForm.isSumInsured = false
    },
    doClose() {
      this.newUom = false
      this.uomDialog = false
      this.uomForm.uom = null
      this.uomForm.uomShortDesc = null
      this.uomForm.uomLongDesc = null
      this.uomForm.isExcess = null
      this.uomForm.isSumInsured = null
      this.resetValidator()
      this.resetMessages()
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newUom) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.uom.menu.createUom
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.post(apiURI, this.uomForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.uom.menu.updateUom
      if (apiURI) {
        this.sumbitting = true
        try {
          const result = await this.$http.put(apiURI, this.uomForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(uom) {
      this.resetMessages()
      this.selectedId.id = uom.uom
      this.selectedId.text = uom.uom + ' - ' + uom.uomShortDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.uom.menu.deleteUom
      if (apiURI) {
        const expand = {
          uom: this.selectedId.id
        }
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.init()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
